export default __webpack_public_path__ + "static/media/pantry1-afterG-768w.f9a6b3c7.png";